import { fql } from 'fauna';

export const getFinalCoursePrice = async (client, courseId) => {
    const response = await client.query(fql`getFinalCoursePrice(${courseId})`);
    return response.data;
}
